import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import CircularProgress from 'material-ui/CircularProgress';
import { purple900 } from 'material-ui/styles/colors';
import { Dimmer, Loader, Label } from 'semantic-ui-react';
import { colorForStatus, } from '../util/colors'
import { filter, UserCell, NumberCell } from '../util/helpers'
import {
    Grid, Row, Col
} from 'react-bootstrap';
import ReactTable from "react-table";
import Card from '../tim-components/Card.jsx';
import RaisedButton from 'material-ui/RaisedButton'
import '../assets/css/bootstrap.css';
import '../assets/sass/light-bootstrap-dashboard.css';
import '../assets/css/demo.css';
import '../assets/css/pe-icon-7-stroke.css';
import 'react-table/react-table.css'
import Cancel from 'material-ui/svg-icons/navigation/cancel';
import { fullWhite } from 'material-ui/styles/colors';

class PaymentInvitations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentinvitations: [],
            isProcessing: true,
        };
    }

    componentDidMount() {
        this.fetchAllPayments();
    }

    sendInvitationReminder = (tx) => {
        const message = `You sure you want to send a payment invitation reminder to ${tx.recipient_matcher}?`
        const response = window.confirm(message)
        if (response) {
            const url = `/admin/support/payment_invitations/reminder/${tx.id}`
            axios.post(url)
                .then(response => {
                    alert("SMS reminder sent successfully!")
                })
                .catch(error => {
                    alert(error)
                })
        }
    }

    cancelInvitation = (tx) => {
        const message = `Are uou sure you want to cancel the payment invitation for ${tx.recipient_matcher}?`
        const response = window.confirm(message)
        if (response) {
            const url = `/admin/support/payment_invitations/cancel/${tx.id}`
            axios.post(url)
                .then(response => {
                    alert("The payment invite has been cancelled.");
                    console.log(response);
                    this.fetchAllPayments();
                })
                .catch(error => {
                    alert("Payment Invitation Cancellation failed: ", error)
                })
        }
    }

    fetchAllPayments = () => {
        axios.get('/admin/support/payment_invitations')
            .then(response => {
                console.log('invitation response: ', response.data)
                const paymentinvitations = response.data.map(tx => {
                    let date;
                    if (moment(tx.updated_at).isValid()) {
                        date = moment(tx.updated_at).format('YYYY-MM-DD | HH:mm')
                    } else {
                        date = "-"
                    }

                    let lastRemindedAt
                    if (moment(tx.reminded_at).isValid()) {
                        lastRemindedAt = moment(tx.reminded_at).format('YYYY-MM-DD | HH:mm')
                    } else {
                        lastRemindedAt = "-"
                    }

                    let error = tx.error_message ? tx.error_message : '-'
                    let sender = `${tx.sender_first_name} ${tx.sender_last_name}`;
                    let recipientName = tx.recipient_first_name ? `${tx.recipient_first_name} ${tx.recipient_last_name}` : '-'
                    let destinationAmount = tx.destination_amount ? parseFloat(tx.destination_amount) : '-'
                    let destinationCurrency = tx.destination_currency ? tx.destination_currency : '-'

                    return {
                        senderId: tx.sender_id,
                        recipientId: tx.recipient_id,
                        sender,
                        recipient: tx.recipient_matcher,
                        status: tx.status,
                        originAmount: parseFloat(tx.origin_amount),
                        originCurrency: tx.origin_currency,
                        destinationAmount,
                        destinationCurrency,
                        updatedAt: date,
                        remindedAt: lastRemindedAt,
                        recipientName,
                        note: tx.note,
                        error,
                        remind: (
                            <div>
                                <span>
                                    {tx.status === 'PENDING' && <RaisedButton
                                        label="Remind"
                                        onTouchTap={() => this.sendInvitationReminder(tx)}
                                    />}
                                </span>
                            </div>
                        ),
                        cancel: (
                            <div>
                                <span>
                                    {tx.status === 'PENDING' && <RaisedButton
                                        label=""
                                        onTouchTap={() => this.cancelInvitation(tx)}
                                        icon={<Cancel
                                            color={fullWhite} />}
                                        secondary={true}
                                    />}
                                </span>
                            </div>
                        )
                    }
                });

                this.setState({
                    paymentinvitations,
                    isProcessing: false
                });
            })
            .catch(error => {
                console.error("Error: ", error);
                this.setState({
                    isProcessing: false
                });
            });
    }

    render() {
        const LoadingIndicator = () => (
            <div className="posCenter">
                <CircularProgress
                    size={70}
                    thickness={3}
                    color={purple900} />
            </div>
        );

        return (
            <div>
                <h2 style={{ textAlign: 'center' }}> All Payment Invitations ({this.state.paymentinvitations.length}) </h2>
                <br /><br /><br />
                <div>
                    {this.state.isProcessing && this.state.paymentinvitations.length === 0 ? <LoadingIndicator /> :
                        <div className="main-content">
                            <Grid fluid>
                                <Row>
                                    <Col md={12}>
                                        <Card
                                            content={
                                                <ReactTable
                                                    data={this.state.paymentinvitations}
                                                    filterable
                                                    columns={[
                                                        {
                                                            Header: "Sender",
                                                            accessor: "sender",
                                                            width: 120,
                                                            Cell: row => {
                                                                return UserCell(row.value, row.original.senderId)
                                                            }
                                                        },
                                                        {
                                                            Header: "Recipient Contact",
                                                            accessor: "recipient",
                                                            width: 120
                                                        },
                                                        {
                                                            Header: "Status",
                                                            accessor: "status",
                                                            Cell: row => {
                                                                const status = row.value
                                                                return (
                                                                    <Label color={colorForStatus(status)} size={'mini'}>{status}</Label>
                                                                )
                                                            },
                                                        },
                                                        {
                                                            Header: "Origin Amount",
                                                            accessor: "originAmount",
                                                            Cell: row => {
                                                                return NumberCell(row.value)
                                                            }
                                                        },
                                                        {
                                                            Header: "Origin Currency",
                                                            accessor: "originCurrency",
                                                        },
                                                        {
                                                            Header: "Destination Amount",
                                                            accessor: "destinationAmount",
                                                            Cell: row => {
                                                                return NumberCell(row.value)
                                                            }
                                                        },
                                                        {
                                                            Header: "Destination Currency",
                                                            accessor: "destinationCurrency"
                                                        },
                                                        {
                                                            Header: "Updated At",
                                                            accessor: "updatedAt",
                                                            width: 140
                                                        },
                                                        {
                                                            Header: "Last Reminded At",
                                                            accessor: "remindedAt",
                                                            width: 140
                                                        },
                                                        {
                                                            Header: "Resolved Name",
                                                            accessor: "recipientName",
                                                            width: 120,
                                                            Cell: row => {
                                                                if (row.value === '-') {
                                                                    return '-'
                                                                } else {
                                                                    return UserCell(row.value, row.original.recipientId)
                                                                }
                                                            }
                                                        },
                                                        {
                                                            Header: "Note",
                                                            accessor: "note",
                                                            style: { 'whiteSpace': 'unset' }
                                                        },
                                                        {
                                                            Header: "Error",
                                                            accessor: "error"
                                                        },
                                                        {
                                                            Header: "Remind",
                                                            accessor: "remind",
                                                            filterable: false,
                                                        },
                                                        {
                                                            Header: "Cancel",
                                                            accessor: "cancel",
                                                            filterable: false,
                                                        }
                                                    ]}
                                                    defaultPageSize={20}
                                                    defaultSorted={[
                                                        {
                                                            id: "updatedAt",
                                                            desc: true
                                                        }
                                                    ]}
                                                    showPaginationTop
                                                    showPaginationBottom
                                                    defaultFilterMethod={filter}
                                                    className="-striped -highlight"
                                                />
                                            }
                                        />
                                    </Col>
                                </Row>
                            </Grid>
                        </div>
                    }
                </div>

                <Dimmer.Dimmable dimmed={this.state.isProcessing}>
                    <Dimmer active={this.state.isProcessing} inverted page>
                        <Loader></Loader>
                    </Dimmer>
                </Dimmer.Dimmable>
            </div>
        );
    }
}

export default PaymentInvitations;
